export default __webpack_public_path__ + "fbc7159ebe30493b98b6abc9ecf36c8e.png";